module.exports = __webpack_public_path__ + "img/20210109_105744.be53f3c5.jpg";